'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

var _time = require('../utils/time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElapsedTimeFormatter = function (_Component) {
  (0, _inherits3.default)(ElapsedTimeFormatter, _Component);

  function ElapsedTimeFormatter() {
    (0, _classCallCheck3.default)(this, ElapsedTimeFormatter);
    return (0, _possibleConstructorReturn3.default)(this, (ElapsedTimeFormatter.__proto__ || (0, _getPrototypeOf2.default)(ElapsedTimeFormatter)).apply(this, arguments));
  }

  (0, _createClass3.default)(ElapsedTimeFormatter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'oe-elapsed-time ' + (this.props.cssClass || '') },
        this.getElapsedTimeText()
      );
    }
  }, {
    key: 'getElapsedTimeText',
    value: function getElapsedTimeText() {
      var _props = this.props,
          time = _props.time,
          textBefore = _props.textBefore,
          abbreviateMonth = _props.abbreviateMonth,
          includeTime = _props.includeTime;

      var minutesAgo = (0, _time.getDifferenceInMinutesToNow)(time);
      var hoursAgo = (0, _time.getDifferenceInHoursToNow)(time);
      var s = textBefore ? textBefore + ' ' : '';
      var daysAgo = Math.floor(minutesAgo / 1440);
      daysAgo = daysAgo !== 0 ? daysAgo : 1;

      if (minutesAgo < 1) {
        s = s + 'Just Now';
      } else if (minutesAgo > 0 && minutesAgo < 60) {
        s = s + (minutesAgo + ' min ago');
      } else if (hoursAgo >= 1 && hoursAgo < 24) {
        s = s + (hoursAgo + ' hour' + (hoursAgo > 1 ? 's' : '') + ' ago');
      } else if (hoursAgo >= 24 && daysAgo < 7) {
        s = s + (daysAgo + ' day' + (daysAgo > 1 ? 's' : '') + ' ago');
      } else {
        s = s + _moment2.default.unix(time).format((0, _time.getFormat)(abbreviateMonth || false, includeTime, false));
      }

      return s;
    }
  }]);
  return ElapsedTimeFormatter;
}(_react.Component);

exports.default = ElapsedTimeFormatter;


ElapsedTimeFormatter.propTypes = {
  cssClass: _propTypes2.default.string,
  textBefore: _propTypes2.default.string,
  time: _propTypes2.default.number,
  abbreviateMonth: _propTypes2.default.bool,
  includeTime: _propTypes2.default.bool
};

ElapsedTimeFormatter.defaultProps = {
  includeTime: false
};